<template>
    <div>
        <!-- есть карта -->
        <div v-if="!isDuplicate && hasCard" class="form__scope _dflex _justify-content-between _flexwrap-mobile form__akkreditiv-error">
            <div class="_w-488 _mb-0-24">
                <h2 class="h2 _mb-24">Уважаемый клиент, у вас уже есть карта нашего банка</h2>
                <div class="p1 _mb-8">Пользуйтесь ее преимуществами уже сейчас</div>
                <div class="p1">Если необходимо открыть еще одну карту, обратитесь в любой офис нашего банка</div>
            </div>
        </div>

        <!-- дубль заявки -->
        <div v-if="isDuplicate && !hasCard" class="form__scope _dflex _justify-content-between _flexwrap-mobile form__akkreditiv-error">
            <div class="_w-488 _mb-0-24">
                <h2 class="h2 _mb-24">Уважаемый клиент, ваша заявка уже обрабатывается</h2>
                <div class="p1">Ранее мы получали от вас заявку на оформление карты. Дождитесь ее получения</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CardsFormV2Error",
        props: {
            hasCard: {
                type: Boolean,
                default: false
            },
            isDuplicate: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            prettyTime() {
                if (!this.$props.time) return 'Время не указано';
                return this.$props.time.split('-').map(i => i + ':00').join('-');
            },
        },
        methods: {
            sendStep(val, step) {
                this.$emit('sendStep', val, step)
            }
        }
    }
</script>
